import React, { useState, useMemo, useCallback } from 'react';
import { PaymentTable } from '@shared/components/tables/PaymentTable';
import EntityTableFilters from '@shared/components/filters/EntityTableFilters';
import { mockPayments } from '@shared/data';
import type { Payment } from '@shared/types/payment.types';

interface TerminalPaymentsTabProps {
  className?: string;
}

const PAGE_SIZE = 10;

export const TerminalPaymentsTab = React.memo<TerminalPaymentsTabProps>(({ className }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [statusFilter, _setStatusFilter] = useState<string>('all');

  const allData = useMemo(() => mockPayments, []);
  const totalItems = allData.length;
  const totalPages = Math.ceil(totalItems / PAGE_SIZE);

  const pageData = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return allData.slice(start, start + PAGE_SIZE);
  }, [allData, currentPage]);

  const handleRowClick = useCallback((payment: Payment) => {
    window.open(`/payments/${payment.transactionRef}`, '_blank');
  }, []);

  const handlePageChange = useCallback((page: number) => {
    setCurrentPage(page);
  }, []);

  return (
    <div className={className}>
      <EntityTableFilters
        entity="payments"
        status={statusFilter}
      />
      <PaymentTable
        data={pageData}
        selectedItems={selectedItems}
        onSelectionChange={setSelectedItems}
        onRowClick={handleRowClick}
        pagination={{
          pageSize: PAGE_SIZE,
          currentPage,
          onPageChange: handlePageChange,
          totalItems,
          totalPages,
        }}
        loading={false}
        statusFilter={statusFilter}
      />
    </div>
  );
});

TerminalPaymentsTab.displayName = 'TerminalPaymentsTab';
